import { action, payload } from 'ts-action'
import { IError, IPayload } from 'models/Global'
import { ITimesheet } from 'models/Timesheet'

export const GetTimesheets = action('GetTimesheets', payload<IPayload<ITimesheet[]>>())
export const GetTimesheetsErrors = action('GetTimesheetsErrors', payload<IError>())
export const TimesheetsFetching = action('TimesheetsFetching', payload<boolean>())
export const ClearTimesheets = action('ClearTimesheets')
